var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Startup',{attrs:{"title":"Activating Account","message":"Please wait while we activate your account..."}})
}
var staticRenderFns = []

export { render, staticRenderFns }